import { Button, cn } from '@scatterlab/zeta-core';
import { VariantProps } from 'class-variance-authority';
import {
  ComponentPropsWithoutRef,
  ComponentRef,
  createElement,
  ElementType,
  memo,
  RefAttributes,
} from 'react';

import { tabBarItem } from '../styles';

export type TabBarItemProps<Component extends ElementType = typeof Button> =
  ComponentPropsWithoutRef<Component> &
    VariantProps<typeof tabBarItem> &
    RefAttributes<ComponentRef<Component>> & {
      component?: Component;
      label: string;
    };

const TabBarItem = <Component extends ElementType = typeof Button>({
  label,
  active,
  className,
  size,
  component,
  children,
  ...props
}: TabBarItemProps<Component>) =>
  createElement(
    component ?? Button,
    {
      'aria-selected': active as boolean,
      role: 'tab',
      tabIndex: active ? 0 : -1,
      className: cn(tabBarItem({ active, size }), className),
      ...((component ?? Button) === Button ? { type: 'button' } : {}),
      ...props,
    },
    children ?? label,
  );

export default memo(TabBarItem) as typeof TabBarItem;
